import PencomFileUpload from "@/components/input/PencomFileUpload";
import type { FieldConfig } from "@/utils/organizationTypeFields";
import type { Dispatch, SetStateAction } from "react";

export interface EmployerDocumentsSectionProps {
  fields: FieldConfig[];
  documents: Record<string, File | null>;
  setDocuments: Dispatch<SetStateAction<Record<string, File | null>>>;
  documentErrors: string[];
  setDocumentErrors: Dispatch<SetStateAction<string[]>>;
}

export const EmployerDocumentsSection = ({
  fields,
  documents,
  setDocuments,
  documentErrors,
  setDocumentErrors,
}: EmployerDocumentsSectionProps) => {
  return (
    <>
      {fields.map((docConfig) => (
        <PencomFileUpload
          key={docConfig.name}
          id={docConfig.name}
          label={docConfig.label}
          placeholder="Click here or drag and drop to upload"
          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
          maxSize={10}
          hint={docConfig.hint}
          onFileSelect={(file) => {
            setDocuments((prev) => ({
              ...prev,
              [docConfig.name]: file,
            }));

            if (file) {
              setDocumentErrors((prev) =>
                prev.filter((label) => label !== docConfig.label)
              );
            }
          }}
          selectedFile={documents[docConfig.name] || undefined}
          error={
            docConfig.required && documentErrors.includes(docConfig.label)
              ? `${docConfig.label} is required`
              : undefined
          }
        />
      ))}
    </>
  );
};

